/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ creator: NonNullable<unknown> }} Agent_Access_Reason_Others_Personal_ConnectionInputs */



/**
* | output |
* | --- |
* | "it is someone else's personal connection and can't be shared. Ask {creator} to pick another one." |
*
* @param {Agent_Access_Reason_Others_Personal_ConnectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_reason_others_personal_connection = /** @type {((inputs: Agent_Access_Reason_Others_Personal_ConnectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Reason_Others_Personal_ConnectionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Das ist die persönliche Verbindung einer anderen Person und kann nicht geteilt werden. Bitten Sie ${i?.creator}, eine andere auszuwählen.`)
	return /** @type {LocalizedString} */ (`it is someone else's personal connection and can't be shared. Ask ${i?.creator} to pick another one.`)
});